import { useCallback } from "react";

export function useResetForceResetPassword(setForceResetPassword: React.Dispatch<boolean>) {
    const resetForceResetPassword = useCallback(() => {
        console.log("resetting mfa");
        setForceResetPassword(false);
    }, [setForceResetPassword]);

    return { resetForceResetPassword }

}